// pages/RiffAi.js
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { questions } from "./riffAiQuestions";
import { RiffQuestion } from "../components/RiffQuestion";
import { IntroducingVoxHeader } from "../components/IntroducingVoxHeader";

export function RiffAi() {
  /* ---------------- react‑hook‑form ---------------- */
  const form         = useForm({ mode: "onChange" });
  const { handleSubmit, control, formState } = form;
  const { isValid }  = formState;
  const navigate     = useNavigate();

  /* ---------------- send answers & jump to /loading ---------------- */
  const submit = (answers) => {
    navigate("/riffai/loading", { state: { answers } });
  };

  /* ---------------- UI ---------------- */
  return (
    <div style={{ background: "#000", minHeight: "100vh" }}>
      {/* ——— header on black ——— */}
      <IntroducingVoxHeader />

      {/* ——— question blocks ——— */}
      <FormProvider {...form}>
        {questions.map((q, idx) => (
          <RiffQuestion
            key={q.id}
            q={q}
            control={control}
            dark={idx % 2 === 1}     /* alternate black / white */
          />
        ))}

        <div style={{ textAlign: "center", padding: "2rem 0" }}>
          <button
            onClick={handleSubmit(submit)}
            disabled={!isValid}
            style={{
              padding: ".9rem 3rem",
              border: "none",
              borderRadius: 25,
              background: isValid ? "#930707" : "#666",
              color: "#fff",
              fontFamily: "Anybody",
              fontSize: "1.4rem",
              cursor: isValid ? "pointer" : "default",
              opacity: isValid ? 1 : 0.7,
              transition: "background .2s"
            }}
          >
            GENERATE
          </button>
        </div>
      </FormProvider>
    </div>
  );
}
